// https://mrpmorris.blogspot.com/2017/08/angular-composite-controls-formgroup-formgroupname-reactiveforms.html
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SharedEditLocationSectionComponent } from '../shared-edit-location-section.component';
import { Store } from '@ngrx/store';
import { EditLocationLocalStore } from '../../edit-location-local-store.service';
import { PushPipe } from '@ngrx/component';
import { EditableTextualInputComponent } from '../../editable-inputs/editable-textual-input/editable-textual-input.component';
import { IntersectionObserverDirective } from '../../../../../directives/general-intersection/intersection-observer.directive';

@Component({
    selector: 'app-basic-information-section',
    templateUrl: './basic-information.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        IntersectionObserverDirective,
        EditableTextualInputComponent,
        PushPipe,
    ],
})
export class BasicInformationSectionComponent extends SharedEditLocationSectionComponent {

  constructor(protected store: Store, protected localStore: EditLocationLocalStore) {
    super(store, localStore);
  }

}
